/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import IAppMenuContext from "./IAppMenuContext";

interface IAppMenuContextState {
    isOpen: boolean;
    hauptMenuSichtbar: boolean;
    grundeinstellungenMenuSichtbar: boolean;
    supporteinstellungenMenuSichtbar: boolean;
}

export default class AppMenuContextInstance implements IAppMenuContext {
    private readonly _state: IAppMenuContextState;
    private readonly _setState: React.Dispatch<React.SetStateAction<IAppMenuContextState>>;

    constructor() {
        [this._state, this._setState] = useState<IAppMenuContextState>({
            isOpen: false,
            hauptMenuSichtbar: true,
            grundeinstellungenMenuSichtbar: false,
            supporteinstellungenMenuSichtbar: false,
        });
    }

    public get isOpen(): boolean {
        return this._state.isOpen;
    }

    public get hauptMenuSichtbar(): boolean {
        return this._state.hauptMenuSichtbar;
    }

    public get grundeinstellungenMenuSichtbar(): boolean {
        return this._state.grundeinstellungenMenuSichtbar;
    }

    public get supporteinstellungenMenuSichtbar(): boolean {
        return this._state.supporteinstellungenMenuSichtbar;
    }

    public oeffne() {
        this._setState(prevState => ({ ...prevState, isOpen: true }));
    }

    public schliesse() {
        this._setState({ isOpen: false, hauptMenuSichtbar: true, grundeinstellungenMenuSichtbar: false, supporteinstellungenMenuSichtbar: false });
    }

    public readonly zeigeSupporteinstellungenMenu = () => {
        this._setState({
            isOpen: true,
            hauptMenuSichtbar: false,
            grundeinstellungenMenuSichtbar: false,
            supporteinstellungenMenuSichtbar: true,
        });
    };

    public readonly zeigeGrundeinstellungenMenu = () => {
        this._setState({
            isOpen: true,
            hauptMenuSichtbar: false,
            grundeinstellungenMenuSichtbar: true,
            supporteinstellungenMenuSichtbar: false,
        });
    };

    public readonly zeigeHauptMenu = () => {
        this._setState({
            isOpen: true,
            hauptMenuSichtbar: true,
            grundeinstellungenMenuSichtbar: false,
            supporteinstellungenMenuSichtbar: false,
        });
    };
}
